import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowBack, MoreVert } from '@mui/icons-material';
import AssistantCommandPalette from './AssistantCommandPalette';
import { useTheme } from '../../context/ThemeContext';

export default function AssistantLayout({ children }) {
  const [commandOpen, setCommandOpen] = useState(false);
  const { theme } = useTheme();

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        e.stopPropagation();
        setCommandOpen((o) => !o);
      }
      if (e.key === 'Escape') setCommandOpen(false);
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, []);

  return (
    <div
      className={
        'assistant-page flex min-h-0 flex-col ' + (theme === 'light' ? 'assistant-page-light' : '')
      }
    >
      <header className="shrink-0">
        <div className="w-full px-4 sm:px-6 lg:px-10 h-14 flex items-center justify-between">
          <div className="flex items-center gap-3 min-w-0">
            <div
              className={'font-semibold ' + (theme === 'light' ? 'text-slate-900' : 'text-slate-100')}
              style={{
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Segoe UI", system-ui, sans-serif',
                fontSize: 20,
              }}
            >
              Netikash AI
            </div>
            {/* retour discret (facultatif, mais utile mobile) */}
            <Link
              to="/"
              className="lg:hidden ml-1 text-slate-500 hover:text-amber-500 transition-colors dark:text-slate-400 dark:hover:text-amber-400"
              aria-label="Retour"
            >
              <ArrowBack sx={{ fontSize: 18 }} />
            </Link>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            <button
              type="button"
              onClick={() => setCommandOpen(true)}
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full border border-amber-400/20 bg-white/60 text-slate-900 text-sm hover:bg-amber-400/10 transition-colors dark:border-amber-400/25 dark:bg-slate-800/80 dark:text-slate-100 dark:hover:bg-slate-700/90"
              aria-label="Choisir le modèle"
            >
              IA support-1o
            </button>
            <button
              type="button"
              onClick={() => setCommandOpen(true)}
              className="hidden"
              aria-label="Menu assistant"
              title="Commandes (⌘K)"
            >
              <MoreVert fontSize="small" />
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 min-h-0 overflow-hidden">
        <div className="h-full">{children}</div>
      </main>

      <AssistantCommandPalette
        isOpen={commandOpen}
        onClose={() => setCommandOpen(false)}
      />
    </div>
  );
}
